<template>
  <div class="my-account" v-show="loaded">
    <vue-headful title="My Account" />
    <h1>MY ACCOUNT</h1>
    <hr />

    <AccountLoader v-if="apiLoading" />
    <v-container v-if="apiLoaded">
      <v-flex xs12>
        <AccountUpdate
          v-if="showForm"
          :hg-api-error-messages="errorMessages"
          :hg-api-loading="isLoadingApi"
          :hg-customer="currentUser"
          :hg-account-last-modified-response="accountLastModified"
          @clearApiErrors="clearApiErrors"
          @userUpdated="userUpdated" />
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import BaseViewComponent from '@/components/Shared/BaseViewComponent.vue';
import AccountLoader from '@/components/Loaders/AccountLoader.vue';
import AccountUpdate from '../Account/AccountUpdate.vue';

export default {
  name: 'myAccount',
  extends: BaseViewComponent,
  components: {
    AccountUpdate,
    AccountLoader,
  },
  async mounted() {
    this.initialHydration([
      this.$store.dispatch('User/loadMe'),
      this.$store.dispatch('User/getAccountLastModified', this.currentUser.personId),
    ]);
  },
  computed: {
    ...mapState({
      loaded: state => state.loaded,
    }),
    ...mapState('Customer', {
      customerPasswordError: state => state.passwordError,
      customerPasswordLoading: state => state.passwordLoading,
    }),
    ...mapState('User', {
      currentUser: state => state.currentUser,
      userSaveError: state => state.saveError,
      userSaveLoading: state => state.saveLoading,
      accountLastModified: state => state.AccountLastModified,
    }),
    errorMessages() {
      const errorMessages = [];
      if (this.customerPasswordError) {
        errorMessages.push('There was an error while saving your password. Please double check your inputs and try again.');
      }

      if (this.userSaveError) {
        errorMessages.push('There was an error while saving your user account. Please double check your inputs and try again.');
      }

      return errorMessages;
    },
    isLoadingApi() {
      return (this.customerPasswordLoading || this.userSaveLoading);
    },
    showForm() {
      return this.loaded
        && this.currentUser;
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (!to.hash) { /* ignore anchor tags for scrolling */
      this.load(this.currentUser.legacyId);
      next();
    }
  },
  methods: {
    async load(id) {
      await this.$store.dispatch('Customer/loadCustomer', id);
    },
    clearApiErrors() {
      this.$store.commit('Customer/setPasswordError', null);
      this.$store.commit('User/setSaveError', null);
    },
    userUpdated(user) {
      this.$emit('userUpdated', user);
      this.$store.dispatch('User/getAccountLastModified', this.currentUser.personId);
    },
  },
};
</script>


<style lang="scss" scoped>
@import '../../styles/vars/theme';

hr {
  border: solid 2px $theme-color-primary;
  margin-top: 40px;
  width: 100%;
}

.my-account {
  padding: 50px;
}

@media all and (max-width: 655px) {
  .my-account {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
